export default "__VITE_ASSET__8a9c93de__"